import PDFDocument from "pdfkit/js/pdfkit.standalone";

export const resetForm = () => {
  window.location.href = "https://www.paddleuaps.com";
};

export const getRandomName = () => {
  const nameLength = 32;
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < nameLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const getSignatureAsPNG = (svgRef) => {
  return new Promise((resolve, reject) => {
    const svgelm = svgRef.current?.svg?.cloneNode(true);
    const width = svgRef.current?.svg?.clientWidth || 0;
    const height = svgRef.current?.svg?.clientHeight || 0;

    if (!svgelm) return reject("SVG element not found");

    svgelm.setAttribute("width", width.toString());
    svgelm.setAttribute("height", height.toString());
    svgelm.setAttribute("viewBox", `0 0 ${width} ${height}`);

    const data = new XMLSerializer().serializeToString(svgelm);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    canvas.width = width;
    canvas.height = height;

    img.onload = () => {
      ctx?.drawImage(img, 0, 0);
      const pngDataUrl = canvas.toDataURL("image/png");
      resolve(pngDataUrl);
    };

    img.onerror = () => {
      reject("Failed to load SVG into image");
    };

    img.src = `data:image/svg+xml;base64,${window.btoa(
      unescape(encodeURIComponent(data))
    )}`;
  });
};

export const getPDF = async (params) => {
  return new Promise(async (resolve, reject) => {
    const {
      name,
      birthday,
      phone,
      email,
      signature,
      negligentCheck,
      nameGuardian,
      emailGuardian,
      signatureGuardian,
    } = params;
    const signaturePNG = signature.current
      ? await getSignatureAsPNG(signature)
      : null;
    const signatureGuardianPNG = signatureGuardian.current
      ? await getSignatureAsPNG(signatureGuardian)
      : null;

    const { blobStream } = window;
    const doc = new PDFDocument();
    const stream = doc.pipe(blobStream());

    stream.on("finish", () => {
      const url = stream.toBlobURL("application/pdf");
      let blob = stream.toBlob("application/pdf");
      // const a = document.createElement("a");
      // a.download = "signature.pdf";
      // a.href = url;
      // a.click();
      resolve(blob);
    });

    const inputColor = "#0000cc";

    doc
      .fontSize(10)
      .font("Helvetica-Bold")
      .text("Assumption of Risk and Waiver of Claims and Liabilities", {
        align: "center",
      })
      .moveDown(0.2)
      .font("Helvetica")
      .text(
        "Alberta Whitewater Association - ASSUMPTION OF RISK AND WAIVER OF CLAIMS AND LIABILITY AGREEMENT",
        { align: "center" }
      )
      .moveDown(0.5);

    const leftX = doc.x;
    const rightX = 300;
    const yStart = doc.y;

    // Participant Info
    doc
      .font("Helvetica-Bold")
      .text("Participant Information", leftX, yStart)
      .font("Helvetica")
      .text("Participant Name: ", leftX, doc.y, { continued: true })
      .fillColor(inputColor)
      .text(name)
      .fillColor("black")
      .text("Birthday: ", leftX, doc.y, { continued: true })
      .fillColor(inputColor)
      .text(birthday.format("YYYY-MM-DD"))
      .fillColor("black")
      .text("Phone Number: ", leftX, doc.y, { continued: true })
      .fillColor(inputColor)
      .text(phone)
      .fillColor("black")
      .text("Email: ", leftX, doc.y, { continued: true })
      .fillColor(inputColor)
      .text(email)
      .fillColor("black");

    // Guardian Info
    doc.y = yStart;
    doc
      .font("Helvetica-Bold")
      .text("Guardian Information", rightX, yStart)
      .font("Helvetica-Oblique")
      .text("If the Participant is younger than 18 years old", rightX, doc.y)
      .font("Helvetica")
      .text("Parent/Guardian Name: ", rightX, doc.y, { continued: true })
      .fillColor(inputColor)
      .text(nameGuardian || "N/A")
      .fillColor("black")
      .text("Email: ", rightX, doc.y, { continued: true })
      .fillColor(inputColor)
      .text(emailGuardian || "N/A")
      .fillColor("black")
      .moveDown(2);

    // Reset layout to full-width
    doc.x = leftX;

    // Agreement Content
    doc
      .font("Helvetica")
      .text(
        "This Agreement must be signed by the Participant and/or the Participant's parent/guardian (if applicable, when the Participant is younger than 18 years old) prior to participation. The Participant acknowledges and agrees to the terms outlined in this document. When applicable, the Participant's parent/guardian acknowledges and agrees to the terms on behalf of the Participant."
      )
      .moveDown(0.5);

    doc.font("Helvetica-Bold").text("ACTIVITIES").font("Helvetica");
    doc
      .text(
        "The Participant is voluntarily participating in canoeing and/or kayaking and the spectating, orientation, instruction, activities, competitions, programs, and services (collectively the “Activities”) of the Alberta Whitewater Association. The Activities may include but are not limited to including lessons, instructional sessions, river runs, competitions, races, practice runs, training, personal or strength training, dry land training, training using machines or weights, and other aerobic and anaerobic activities. The Alberta Whitewater Association, its clubs, and its affiliated discipline associations and their respective Directors, Officers, committee members, members, employees, coaches, volunteers, officials, participants, agents, sponsors, owners/operators of the facilities/courses in which the Activities take place, and representatives (collectively the “Organization”) are not responsible for any injury, personal injury, damage, property damage, expense, loss of income or loss of any kind suffered by a Participant during or as a result of the Activities and/or, when the Participant is 18 years old or older, when caused by the negligence of the Organization."
      )
      .moveDown(0.5);

    doc.font("Helvetica-Bold").text("RISKS").font("Helvetica");
    doc
      .text(
        "The Activities have foreseeable and unforeseeable inherent risks, hazards and dangers that no amount of care, caution or expertise can eliminate. These inherent physical risks include:\na) Health: executing physical techniques; physical exertion; stretching; dehydration; fatigue; hypothermia or hyperthermia; cardiovascular workouts; rapid movements and stops; lack of fitness or conditioning; traumatic injury; sprains and fractures, spinal cord injuries, bacterial infections; rashes; and the transmission of communicable diseases, including viruses of all kinds\nb) Premises: drowning; falls; collisions with objects or barriers that are a part of the premises; dangerous, unsafe, or irregular conditions on water, ground, or other surfaces; temperature of the water; interactions with animals and plants; extreme weather conditions and hazards such as thunderstorms and lightning; and travel to and from the premises\nc) Use of equipment: mechanical failure of the equipment; negligent design or manufacture of the equipment; the provision of, or the failure by, the Organization to provide any warnings, directions, instructions or guidance as to the use of the equipment; failure to wear safety or protective equipment; and failure to use or operate equipment within the Participant's own ability\nd) Contact: contact with participants, kayaks, canoes, paddles, vehicles, plants or animals, or other persons; and other contact that may lead to serious bodily injury, including but not limited to concussions and/or other brain injury or serious spinal injury\ne) Advice: negligent advice regarding the Activities\nf) Ability: failing to act safely or within the Participant's own ability or within designated areas\ng) Sport: canoeing and kayaking, swimming, swift water rescues, camping and their inherent risks, including becoming lost or disoriented during participation\nh) Conduct: the Participant's conduct and conduct of other persons including any physical altercation between participants\ni) Travel: travel to and from the Activities"
      )
      .moveDown(0.5);

    doc
      .text(
        "Negligence. The Organization may be negligent, which may include failure by the Organization to take reasonable steps to safeguard or protect the Participant from the risks, dangers and hazards associated with participation in the Activities."
      )
      .moveDown(1);

    // Negligent checkbox
    doc.fillColor("black").text("[", { continued: true });
    if (negligentCheck) {
      doc.fillColor(inputColor).text("x", { continued: true });
    } else {
      doc.text(" ", { continued: true });
    }
    doc
      .fillColor("black")
      .text(
        `] The Participant accepts that the Organization may be negligent (check only if the Participant is 18 years old or older).`
      )
      .moveDown(1);

    // TERMS
    doc.font("Helvetica-Bold").text("TERMS").font("Helvetica");
    doc
      .text(
        "In consideration of the Organization allowing the Participant to participate in the Activities, the Participant agrees:\na) That the Participant is not relying on any oral or written statements made by the Organization or their agents\nb) That the Participant's mental and physical condition is appropriate to participate in the Activities\nc) To comply with the rules and regulations for participation in the Activities\nd) To comply with the rules of the facility, course or equipment as well as any directions or instructions from the Organization\ne) That if the Participant observes an unusual significant hazard or risk, the Participant will remove themselves from participation\nf) That the Organization may secure transport to emergency medical services as it deems necessary for the Participant's immediate health and safety, and that the Participant shall be financially responsible for such services\ng) The risks associated with the Activities are increased when the Participant is impaired and the Participant will not participate if impaired in any way\nh) That it is the Participant's (or the Participant's parent/guardian, if applicable) sole responsibility to assess whether any Activities are too difficult for the Participant. By the Participant commencing an Activity, the Participant (or the Participant's parent/guardian, if applicable) acknowledges and accepts the suitability and conditions of the Activity\ni) That the Participant (or the Participant's parent/guardian, if applicable) is responsible for choosing the Participant's safety or protective equipment and the secure fitting of that equipment"
      )
      .moveDown(0.5);

    // STATUS
    doc.font("Helvetica-Bold").text("ACTIVITIES STATUS").font("Helvetica");
    doc
      .text(
        "The Participant (and the Participant's parent/guardian, if applicable) agrees that the Organization has the discretion to cancel or modify the structure of any Activities due to a public health or safety issue.\nThe Participant (and the Participant's parent/guardian, if applicable) agrees that the Organization may implement and enforce guidelines for participation that may include requiring that personal protective equipment be worn by Participants (and their parents/guardians, if applicable). When required, the Participant is responsible for providing their own personal protective equipment."
      )
      .moveDown(0.5);

    // CONSENT
    doc.font("Helvetica-Bold").text("IMAGE CONSENT").font("Helvetica");
    doc
      .text(
        "The Participant (and the Participant's parent/guardian, if applicable) grants permission to the Organization, without payment of any fee, to photograph and/or record the Participant's image and/or voice and to use this material to promote the sport, the Organization, and/or the Organization's Activities through social media, newsletters, websites, television, film, radio, print and/or displays. The Participant (or the Participant's parent/guardian, if applicable) understands that they waive any claim to remuneration for use of audio/visual materials used for these purposes."
      )
      .moveDown(0.5);

    // DISCLAIMER
    doc.font("Helvetica-Bold").text("DISCLAIMER").font("Helvetica");
    doc
      .text(
        "When the Participant is 18 years old or older, the Participant assumes all risks arising out of, associated with or related to, participation in the Activities and waives any and all claims that the Participant may have now or in the future against the Organization. The Participant, when 18 years old or older, accepts and fully assumes all such risks and possibility of personal injury, death, property damage, expense, and related loss, including loss of income, resulting from participation in the Activities. The Participant forever indemnifies and releases the Organization from any and all liability for any and all claims, demands, actions, damages (including direct, indirect, special and/or consequential), losses, actions, judgments, and costs (including legal fees) (collectively, the “Claims”) which the Participant has or may have in the future, that might arise out of, result from, or relate to, participation in the Activities, even though such Claims may have been caused by any manner whatsoever, including but not limited to, the Organization's negligence, gross negligence, negligent rescue, omissions, carelessness, breach of contract and/or breach of any statutory duty of care of the Organization.\n\nFor all Participants. The Organization is not responsible or liable for any damage to the Participant's vehicle, property, or equipment that may occur as a result of the Activities. This Agreement is intended to be as broad and inclusive as is permitted by law of the Province of Alberta and if any portion thereof is held invalid, the balance shall continue in full legal force and effect. The Participant (or the Participant's parent/guardian, if applicable) agrees to file any lawsuit against the Organization in the Province of Alberta and further agrees that the substantive law of the Province of Alberta will apply with regard to conflict of law rules."
      )
      .moveDown(0.5);

    // ACKNOWLEDGMENT
    doc.font("Helvetica-Bold").text("ACKNOWLEDGMENT").font("Helvetica");
    doc
      .text(
        "The Participant (and the Participant's parent/guardian, if applicable) acknowledges that they have read and understand this Agreement, that they have executed this Agreement voluntarily, and that this Agreement is to be binding upon themselves, their heirs, spouse, children, parents, guardians, next of kin, executors, administrators and legal or personal representatives. They further acknowledge that by signing this Agreement they have waived their right to maintain a lawsuit against the Organization on the basis of any claims from which they have released herein."
      )
      .moveDown(1);

    // SIGNATURES
    doc
      .font("Helvetica-Bold")
      .text(
        "Participant Signature (if the Participant is 18 years old or older)"
      )
      .moveDown(0.2);
    if (signaturePNG) {
      doc.image(signaturePNG, { width: 400 });
    }

    doc
      .moveDown(0.5)
      .font("Helvetica-Bold")
      .text(
        "Parent/Guardian Signature (if the Participant is younger than 18 years old)"
      )
      .moveDown(0.2);
    if (signatureGuardianPNG) {
      doc.image(signatureGuardianPNG, { width: 400 });
    }

    doc.end();
  });
};
